import {  CodeToText } from 'element-china-area-data'
// 数据合并
export function mergeRecursive(source, target) {
  for (var p in target) {
    try {
      if (target[p].constructor == Object) {
        source[p] = mergeRecursive(source[p], target[p])
      } else {
        source[p] = target[p]
      }
    } catch (e) {
      source[p] = target[p]
    }
  }
  return source
}
/**
 *  将富文本格式化为纯文字 - 新版
 */
export function areaCodeToText(areaCodeStr) {
  if (!areaCodeStr) {
    return '地区code码不能为空'
  }
  const codeArray = areaCodeStr.split(',')
  const textArray = codeArray.map(code => CodeToText[code])
  return textArray.join(',')
}
